import releaseService from '../services/releaseService';

export const getPaginatedReleases = async (params, setState, setLoading) => {
  setLoading(true);
  console.log(params);
  try {

    var magazine_id = null;
    var magazineL = localStorage.getItem('magazine');
    if (magazineL) {
      magazine_id = JSON.parse(magazineL).magazine_id;
    }

    const result = await releaseService.fetchReleases(params, magazine_id);
    if (result && result.status) {
      setState({
        releases: result.data || [],
        offset: result.offset,
        perPage: result.per_page,
        page: result.page,
        total: result.total,
        q: params.q,
        loading: false,
      });
    } else {
      console.error('Failed to fetch releases');
    }
  } catch (error) {
    console.error("Failed to fetch releases", error);
  } finally {
    setLoading(false);
  }
};

export const loadReleases = async (setReleases) => {
  var magazine_id = null;
  var magazineL = localStorage.getItem('magazine');
  if (magazineL) {
    magazine_id = JSON.parse(magazineL).magazine_id;
  }
  const data = await releaseService.fetchAllReleases(magazine_id);
  setReleases(data);
};


export const getReleaseById = async (params, setRelease) => {
  const data = await releaseService.fetchReleaseByID(params);
  setRelease(data);
};


export const updateReleaseById = async (params, updatedData, setRelease) => {
  const res = await releaseService.updateReleaseById(params, updatedData);
  return res;
};





